import { render, staticRenderFns } from "./UfiCertifiedMember.vue?vue&type=template&id=59d61df8&scoped=true"
import script from "./UfiCertifiedMember.vue?vue&type=script&lang=js"
export * from "./UfiCertifiedMember.vue?vue&type=script&lang=js"
import style0 from "./UfiCertifiedMember.vue?vue&type=style&index=0&id=59d61df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d61df8",
  null
  
)

export default component.exports